import { Country } from './Country';

export type Address = {
    id?: string;
    street: string;
    city: string;
    postCode: string;
    country: Country | (string & {});
    lat: string;
    lon: string;
};

export type AddressInput = {
    city: string;
    country: Country | (string & {});
    flatNumber?: string;
    floor?: string;
    intercom?: string;
    lat: string;
    line2?: string;
    lon: string;
    postCode: string;
    state?: string;
    street: string;
};

export enum UserAddressType {
    HOME = 'HOME',
    WORK = 'WORK',
    OTHER = 'OTHER',
}
